import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ComparisonSection } from './components/ComparisonSection';
import { AudienceSection } from './components/AudienceSection';
import { ContentSection } from './components/ContentSection';
import { FaqSection } from './components/FaqSection';
export function App() {
  return <div className="min-h-screen font-sans text-gray-900 bg-white selection:bg-[#BC6C25] selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <PainSection data-id="element-3" />
        <ComparisonSection data-id="element-4" />
        <AudienceSection data-id="element-5" />
        <ContentSection data-id="element-6" />
        <FaqSection data-id="element-7" />
      </main>

      <footer className="bg-[#1B4332] text-white/40 py-8 text-center text-sm" data-id="element-8">
        <div className="max-w-6xl mx-auto px-4" data-id="element-9">
          <p data-id="element-10">
            © {new Date().getFullYear()} Guía de Recetas para Diabetes. Todos
            los derechos reservados.
          </p>
          <p className="mt-2 text-xs" data-id="element-11">
            Este producto es una guía educativa y no sustituye el consejo médico
            profesional.
          </p>
        </div>
      </footer>
    </div>;
}